/* global AppleID */
import React from 'react';
import PropTypes from 'prop-types';
import { parseJwt } from 'helpers/AnonymousHelper';
import SignInAppleButton from './components/SignInAppleButton';
import Style from './SignInApple.module.scss';
import { inject } from '../../../../external-scripts/AsyncScriptLoader'

const appleSignInScript =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

const SignInApple = ({
  isUpsell,
  onAppleSignIn,
  setAppleEmail,
  setAppleToken,
  setIsAppleEmailShared,
  isConsolidatedSignUp,
}) => {
  const {
    appleLoginText,
    signInWithApple_clientID,
    signInWithApple_ShareUpsellBtnText: appleUpsellBtnText,
  } = window.Language;

  const handleSignIn = async () => {
    await inject(appleSignInScript);

    AppleID?.auth.init({
      clientId: signInWithApple_clientID,
      scope: 'name email',
      redirectURI: window.location.origin,
      usePopup: true,
    });
    // load apple script and do every thing else here for apple sign in
    AppleID?.auth.signIn();
  };

  // Listen for authorization success
  document.addEventListener('AppleIDSignInOnSuccess', result => {
    const { authorization } = result.detail;
    const parsedJwt = parseJwt(authorization.id_token);
    const { email, is_private_email } = parsedJwt;
    setAppleToken(authorization.id_token);
    setAppleEmail(email);
    setIsAppleEmailShared(!is_private_email);
    onAppleSignIn(authorization.id_token);
  });

  document.addEventListener('AppleIDSignInOnFailure', error => {});

  return (
    <>
      {isUpsell ? (
        <button className={Style.btnPrimary} onClick={handleSignIn}>
          {appleUpsellBtnText}
        </button>
      ) : (
        <SignInAppleButton
          handleSignIn={handleSignIn}
          buttonText={appleLoginText}
          isConsolidatedSignUp={isConsolidatedSignUp}
        />
      )}
    </>
  );
};

SignInApple.propTypes = {
  isConsolidatedSignUp: PropTypes.bool,
  isUpsell: PropTypes.bool,
  onAppleSignIn: PropTypes.func,
  setAppleEmail: PropTypes.func,
  setAppleToken: PropTypes.func,
  setIsAppleEmailShared: PropTypes.func,
};

export default SignInApple;
